/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-05T16:23:43.389
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentPropertyDeliveryItem,
	getRentPropertyDeliveryItemCreateInit,
	getRentPropertyDeliveryItemEditInit,
	getRentPropertyDeliveryItemView,
	deleteRentPropertyDeliveryItem
} from '@api/rentmanage/RentPropertyDeliveryItem';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentPropertyDeliveryItemCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryItemCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPropertyDeliveryItemEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryItemEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentPropertyDeliveryItem({}, RentPropertyDeliveryItem) {
			return new Promise((resolve, reject) => {
				saveRentPropertyDeliveryItem(RentPropertyDeliveryItem)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentPropertyDeliveryItemView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentPropertyDeliveryItemView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentPropertyDeliveryItem({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentPropertyDeliveryItem({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
